var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPartyPopper(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 14.125L2.5 27.5L15.875 22.7625M5 3.75H5.0125M27.5 10H27.5125M18.75 2.5H18.7625M27.5 25H27.5125M27.5 2.5L24.7 3.4375C23.903 3.70299 23.2229 4.23705 22.776 4.9484C22.3292 5.65976 22.1432 6.50424 22.25 7.3375V7.3375C22.375 8.4125 21.5375 9.375 20.4375 9.375H19.9625C18.8875 9.375 17.9625 10.125 17.7625 11.175L17.5 12.5M27.5 16.25L26.475 15.8375C25.4 15.4125 24.2 16.0875 24 17.225C23.8625 18.1 23.1 18.75 22.2125 18.75H21.25M13.75 2.5L14.1625 3.525C14.5875 4.6 13.9125 5.8 12.775 6C11.9 6.125 11.25 6.9 11.25 7.7875V8.75",
    stroke: "#5A2D00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7497 16.2499C16.1622 18.6624 17.2872 21.4624 16.2497 22.4999C15.2122 23.5374 12.4122 22.4124 9.99966 19.9999C7.58716 17.5874 6.46216 14.7874 7.49966 13.7499C8.53716 12.7124 11.3372 13.8374 13.7497 16.2499Z",
    stroke: "#5A2D00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartyPopper);
export default __webpack_public_path__ + "static/media/party-popper.da08c26c312751adca6f298229ccd1f8.svg";
export { ForwardRef as ReactComponent };